<template>
  <div
    :aria-label="count ? 'badge' : undefined"
    class="relative inline-flex"
  >
    <transition
      enter-active-class="transition-transform duration-1000"
      enter-from-class="scale-0"
      leave-active-class="transition-transform duration-1000"
      leave-to-class="scale-0"
    >
      <span
        v-if="count"
        class="rounded-full text-white text-xs font-bold flex items-center justify-center h-5 min-w-5 bg-orange z-10"
        :class="{ 'absolute top-0 right-0 translate-x-1/2 -translate-y-1/2': !!$slots.default }"
      >
        <CarvisSpinner
          v-if="loading"
          class="h-3 w-3"
        />
        <span
          v-else
          class="px-1"
        >
          {{ count }}
        </span>
      </span>
    </transition>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  loading?: boolean
  count?: number
}
>()
</script>
